import { TFunction } from "i18next";

export function formatIdNumber(input: string, country: string) {
  if (country === "US") {
    // remove all non-dash and non-numerals
    let val = input.replace(/[^\d-]/g, "");

    // add the first dash if number from the second group appears
    val = val.replace(/^(\d{3})-?(\d{1,2})/, "$1-$2");

    // add the second dash if numbers from the third group appears
    val = val.replace(/^(\d{3})-?(\d{2})-?(\d{1,4})/, "$1-$2-$3");

    // remove misplaced dashes
    val = val
      .split("")
      .filter((val, idx) => {
        return val !== "-" || idx === 3 || idx === 6;
      })
      .join("");

    // enforce max length
    return val.substring(0, 11);
  } else if (country === "GB") {
    // remove any invalid characters and convert letters to uppercase
    let val = input.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase();

    val = val.replace(
      /(\w{2})s?(\w{2})s?(\w{2})s?(\w{2})s?(\w)/,
      "$1 $2 $3 $4 $5"
    );

    // remove misplaced spaces
    val = val
      .split("")
      .filter((val, idx) => {
        return val !== " " || idx === 2 || idx === 5 || idx === 8 || idx === 11;
      })
      .join("");

    // enforce max length
    return val.substring(0, 13);
  } else {
    // remove all non-space and non-numerals
    let val = input.replace(/[^\d\s]/g, "");

    // add the second space if numbers from the third group appears
    val = val.replace(/^(\d{3})s?(\d{3})s?(\d{1,3})/, "$1 $2 $3");

    // remove misplaced spaces
    val = val
      .split("")
      .filter((val, idx) => {
        return val !== " " || idx === 3 || idx === 7;
      })
      .join("");

    // enforce max length
    return val.substring(0, 11);
  }
}

export function parseIdNumber(val: string, country: string) {
  if (country === "US") {
    return val.replaceAll("-", "");
  } else if (country === "GB") {
    return val.replaceAll(" ", "").toUpperCase();
  } else {
    return val.replaceAll(" ", "");
  }
}

export function parseErrorMessage(t: TFunction, country: string) {
  if (country === "US") {
    return t<string>("Enter a valid 9-digit Social Security number");
  } else if (country === "GB") {
    return t<string>(
      "Enter a National Insurance number that is 2 letters, 6 numbers, then A, B, C or D, like SR 12 34 56 C"
    );
  } else {
    return t<string>("Enter a valid 9-digit Social Insurance number");
  }
}

export function getPlaceholderText(country: string) {
  if (country === "US") {
    return "000-00-000";
  } else if (country === "GB") {
    return "AB 00 00 00 C";
  } else {
    return "000 000 000";
  }
}

export function getIdNumberLabels(t: TFunction, country: string) {
  if (country === "US") {
    return t<string>("Social Security Number (SSN)");
  } else if (country === "GB") {
    return t<string>("National Insurance number (NI)");
  } else {
    return t<string>("Social Insurance number (SIN)");
  }
}

export function getTestId(country: string) {
  if (country === "US") {
    return "ssn";
  } else if (country === "GB") {
    return "ni";
  } else {
    return "ssi";
  }
}
